import React from "react";
import {Box, Divider, Grid, Typography, Link} from "@mui/material";

interface textRules {
  columnA: 'regular' | 'bold' | 'italic' | 'bold-italic'
  columnB: 'regular' | 'bold' | 'italic' | 'bold-italic'
}

interface alignments {
  columnA: 'left' | 'center' | 'right'
  columnB: 'left' | 'center' | 'right'
}

interface shortlistProps {
  data: Object;
  id?: string;
  FirstColWidth?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
  convertLinks?: boolean;
  textAlign?: alignments;
  textFormatting?: textRules;
  fontSize?: number;
  lineHeight?: 'condensed' | 'tight' | 'normal' | 'wide' | 'xwide';
  firstLine?: 'none' | 'normal' | 'strong';
  sx?: any
}

const FaShortlist = (props: shortlistProps) => {

  const {
    data,
    id,
    FirstColWidth,
    textAlign,
    textFormatting,
    fontSize,
    lineHeight,
    sx
  } = props;

  const formatting = textFormatting || {columnA: 'regular', columnB: 'regular'};
  const hasFirstDivider = props.firstLine ?? 'none';
  const withLinks = props.convertLinks ?? true;
  
  const lineValue = {
    condensed: "1.25",
    tight: "1.5",
    normal: "1.8",
    wide: "2.25",
    xwide: "3"
  }

  const fontSxColA = {
    fontSize: fontSize ?? 16,
    lineHeight: (lineHeight && lineValue[lineHeight]) ?? 1.5,
    fontWeight: formatting.columnA.indexOf('bold') !== -1 ? 600 : 500,
    fontStyle: formatting.columnA.indexOf('italic') !== -1 ? 'italic' : 'normal',
    textAlign: textAlign?.columnA ?? 'left'
  }

  const fontSxColB = {
    fontSize: fontSize ?? 16,
    lineHeight: (lineHeight && lineValue[lineHeight]) ?? 1.5,
    fontWeight: formatting.columnB.indexOf('bold') !== -1 ? 600 : 500,
    fontStyle: formatting.columnB.indexOf('italic') !== -1 ? 'italic' : 'normal',
    textAlign: textAlign?.columnB ?? 'left'
  }

  function isValidHrefPrefix(href:string) {
    const pattern = /^(http:\/\/|https:\/\/|ftp:\/\/|mailto:|tel:|sms:|geo:|data:|file:|javascript:).*/;
    return pattern.test(href);
  }

  function removeHrefPrefix(href:string) {
    const pattern = /^(http:\/\/|https:\/\/|ftp:\/\/|mailto:|tel:|sms:|geo:|data:|file:|javascript:)/;
    return href.replace(pattern, '');
  }

  return (
      <Box id={id} sx={sx}>
        {(hasFirstDivider !== 'none') &&
            <Divider sx={(hasFirstDivider === 'strong') ? {borderBottomWidth: '1.6px'} : { }}/>
        }
        {Object.entries(data).map(([key, value], i: number) => (
            <>
              <Grid container key={i} spacing={2}>
                <Grid item xs={6} sm={FirstColWidth ?? 4}
                      className={`td-${i}-1`} sx={{padding: '0 1px 0 1px', margin: '0'}}>
                  {(withLinks && isValidHrefPrefix(key))
                      ? <Typography sx={fontSxColA}><Link href={key} underline={"hover"} sx={fontSxColA}>{removeHrefPrefix(key)}</Link></Typography>
                      : <Typography sx={fontSxColA} dangerouslySetInnerHTML={{__html: key}}></Typography>
                  }
                </Grid>
                <Grid item xs={6} sm={FirstColWidth ? 12 - FirstColWidth : 8}
                      className={`td-${i}-2`} sx={{padding: '0 1px 0 1px',  margin: '0'}}>
                  {(withLinks && isValidHrefPrefix(value))
                      ? <Typography sx={fontSxColB}><Link href={value} underline={"hover"}>{removeHrefPrefix(value)}</Link></Typography>
                      : <Typography sx={fontSxColB} dangerouslySetInnerHTML={{__html: value}}></Typography>
                  }
                </Grid>
              </Grid>
              <Divider sx={{margin: '0'}}/>
            </>
        ))}
      </Box>
  );
};
export default FaShortlist;
